export const getToken = () => {
    const tokenValue = localStorage.getItem("tokenValue");
    const tokenType = localStorage.getItem("tokenType");
    return tokenValue && tokenType ? `${tokenType} ${tokenValue}` : 'WEB_USER_GHOST';
}